import * as angular from "angular";
import * as _ from "lodash";
import {BringozToastService} from "../../commons/services/bringoz-toast.service";

export class BillingAlertsService {

  /* @ngInject */
  constructor(private bringozToastService: BringozToastService, private $filter) {
  }

  // BILLING_ACCOUNT_UPDATE //
  updateBillingAccountSuccess() {
    const message = {
      body: 'BILLING_ACCOUNT_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateBillingAccountError() {
    const message = {
      body: 'BILLING_ACCOUNT_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE //
  updateSuccess() {
    const message = {
      body: 'BILLING_UPDATE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateError() {
    const message = {
      body: 'BILLING_UPDATE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getError() {
    const message = {
      body: 'BILLING_GET_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // DELETE //
  removeSuccess(customer) {
    const message = {
      body: 'BILLING_REMOVE_SUCCESS'
    };
    return this.bringozToastService.success(message, {name: customer.firstName + " " + customer.lastName})
  }

  removeError() {
    const message = {
      body: 'BILLING_REMOVE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // ADD PAYMENT METHOD //
  addPaymentMethodSuccess() {
    const message = {
      body: 'BILLING_ADD_PAYMENT_METHOD_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  addPaymentMethodError() {
    const message = {
      body: 'BILLING_ADD_PAYMENT_METHOD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // REMOVE PAYMENT METHOD //
  removePaymentMethodSuccess() {
    const message = {
      body: 'BILLING_REMOVE_PAYMENT_METHOD_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  removePaymentMethodError() {
    const message = {
      body: 'BILLING_REMOVE_PAYMENT_METHOD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CONSOLIDATED_REFUND //
  consolidatedRefundSuccess() {
    const message = {
      body: 'BILLING_CONSOLIDATED_REFUND_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  consolidatedRefundError() {
    const message = {
      body: 'BILLING_CONSOLIDATED_REFUND_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  openDeptError() {
    const message = {
      body: 'BILLING_OPEN_DEPT_ERROR_DETAILS',
      details: 'BILLING_REMOVE_PAYMENT_METHOD_ERROR'
    };
    return this.bringozToastService.error(message)
  }

  // SET DEFAULT PAYMENT METHOD //
  setDefaultPaymentMethodSuccess() {
    const message = {
      body: 'BILLING_SET_DEFAULT_PAYMENT_METHOD_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  setDefaultPaymentMethodError() {
    const message = {
      body: 'BILLING_SET_DEFAULT_PAYMENT_METHOD_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE_INVOICE //
  invoiceCreationRequestSuccess() {
    const message = {
      body: 'BILLING_INVOICE_CREATION_REQUEST_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  invoiceCreationRequestError(error) {
    const message = {
      body: 'BILLING_CREATE_INVOICE_ERROR',
      message: _.get(error, 'more_info'),
      details: _.get(error, 'more_info') ? undefined : 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  deleteInvoiceSuccess() {
    const message = {
      body: 'BILLING_DELETE_INVOICE_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  deleteInvoiceError() {
    const message = {
      body: 'BILLING_DELETE_INVOICE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE_BILLING_ORDER_PRICE_OFFER //
  updateBillingOrderPriceOfferSuccess() {
    const message = {
      body: 'BILLING_UPDATE_BILLING_ORDER_PRICE_OFFER_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateBillingOrderPriceOfferError(error?) {
    const message = {
      body: 'BILLING_UPDATE_BILLING_ORDER_PRICE_OFFER_ERROR',
      details: 'SOMETHING_WENT_WRONG',
      message: _.get(error, 'message')
    };
    return this.bringozToastService.error(message)
  }

  // GET_BILLING_ORDER_PRICE_OFFER
  getBillingOrderPriceOfferError() {
    const message = {
      body: 'BILLING_GET_BILLING_ORDER_PRICE_OFFER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE_BILLING_ACCOUNT_PREFERENCES //
  updateBillingAccountPreferencesSuccess() {
    const message = {
      body: 'BILLING_UPDATE_BILLING_ACCOUNT_PREFERENCES_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateBillingAccountPreferencesError() {
    const message = {
      body: 'BILLING_UPDATE_BILLING_ACCOUNT_PREFERENCES_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  getBillingOrderInvoiceError(){
    const message = {
      body: 'GET_BILLING_ORDER_INVOICE_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  syncPriceOfferSuccess(){
    const message = {
      body: 'SYNC_PRICE_OFFER_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  syncPriceOfferNoUpdateAvailableWarning(){
    const message = {
      body: 'NO_PRICE_OFFER_UPDATE_AVAILABLE'
    };
    return this.bringozToastService.warning(message);
  }

  syncPriceOfferError(){
    const message = {
      body: 'SYNC_PRICE_OFFER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  manualPaidSuccess(){
    const message = {
      body: 'MANUAL_PAID_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  manualPaidError(){
    const message = {
      body: 'MANUAL_PAID_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // CREATE_CONSOLIDATED_BILLING_ORDER //
  createConsolidatedBillingOrderSuccess() {
    const message = {
      body: 'BILLING_CREATE_CONSOLIDATED_BILLING_ORDER_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  // CREATE_CONSOLIDATED_BILLING_ORDER_PARTIAL //
  createConsolidatedBillingOrderPartialSuccess(payload) {

    const reasons = [];
    if (payload.alreadyConsolidated) {
      reasons.push(this.$filter('translate')('X_ALREADY_CONSOLIDATED', {alreadyConsolidated: payload.alreadyConsolidated}))
    }
    if (payload.differentBillingAccount) {
      reasons.push(this.$filter('translate')('X_DIFFERENT_BILLING_ACCOUNTS', {differentBillingAccount: payload.differentBillingAccount}))
    }
    if (payload.notDeliveredStatus) {
      reasons.push(this.$filter('translate')('X_NOT_DELIVERED_STATUS', {notDeliveredStatus: payload.notDeliveredStatus}))
    }

    const message = {
      details: 'BILLING_CREATE_CONSOLIDATED_BILLING_ORDER_PARTIAL_SUCCESS',
      message: _.join(reasons, ', ')
    };
    return this.bringozToastService.success(message)
  }

  createConsolidatedBillingOrderError() {
    const message = {
      body: 'BILLING_CREATE_CONSOLIDATED_BILLING_ORDER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // UPDATE_CONSOLIDATED_BILLING_ORDER //
  updateConsolidatedBillingOrderSuccess() {
    const message = {
      body: 'BILLING_UPDATE_CONSOLIDATED_BILLING_ORDER_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  updateConsolidatedBillingOrderError() {
    const message = {
      body: 'BILLING_UPDATE_CONSOLIDATED_BILLING_ORDER_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EXPORT //
  payManuallySuccess() {
    const message = {
      body: 'BILLING_PAY_MANUALLY_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  payManuallyError() {
    const message = {
      body: 'BILLING_PAY_MANUALLY_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  resetPayManuallySuccess() {
    const message = {
      body: 'RESET_PAY_MANUALLY_BILLING_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  resetPayManuallyError() {
    const message = {
      body: 'RESET_PAY_MANUALLY_BILLING_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // EXPORT //
  exportSuccess() {
    const message = {
      body: 'BILLING_EXPORT_SUCCESS'
    };
    return this.bringozToastService.success(message)
  }

  exportError() {
    const message = {
      body: 'BILLING_EXPORT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // PRINT //
  printError() {
    const message = {
      body: 'BILLING_PRINT_ERROR',
      details: 'SOMETHING_WENT_WRONG'
    };
    return this.bringozToastService.error(message)
  }

  // NOT_ZERO //
  notZeroInfo() {
    const message = {
      body: 'BILLING_NOT_ZERO_INFO'
    };
    return this.bringozToastService.info(message)
  }


}

angular
  .module('bringoz.admin.billing-accounts')
  .service('billingAlertsService', BillingAlertsService);
